import {
  LOAD_AGE_RESTRICTIONS,
  AGE_RESTRICTIONS_LOADED,
  SYNC_FAILED,
  RESET_AGE_RESTRICTIONS,
  RESET_AGE_RESTRICTION,
  AGE_RESTRICTION_DELETED,
  LOAD_AGE_RESTRICTION,
  AGE_RESTRICTION_LOADED,
  SAVE_AGE_RESTRICTION,
  AGE_RESTRICTIONS_SAVED,
  AGE_RESTRICTION_ADDED,
} from './actionTypes';
import { IAgeRestriction } from './types';

export const initialState = {
  error: null,
  ageRestrictionsLoaded: false,
  ageRestrictionLoaded: false,
  ageRestrictions: [] as IAgeRestriction[],
  ageRestriction: null,
  ageRestrictionSaved: false,
  syncing: false,
};

export const reducer = (state = initialState, action: { type: string; payload?: any }) => {
  switch (action.type) {
    case LOAD_AGE_RESTRICTIONS:
      return { ...state, error: null, syncing: true };
    case AGE_RESTRICTIONS_LOADED:
      return {
        ...state,
        error: null,
        ageRestrictions: action.payload,
        syncing: false,
        ageRestrictionsLoaded: true,
      };
    case LOAD_AGE_RESTRICTION:
      return { ...state, error: null, syncing: true };
    case AGE_RESTRICTION_LOADED:
      return {
        ...state,
        error: null,
        ageRestriction: action.payload,
        syncing: false,
        ageRestrictionLoaded: true,
      };
    case RESET_AGE_RESTRICTIONS:
      return initialState;
    case RESET_AGE_RESTRICTION:
      return { ...state, ageRestriction: null };
    case AGE_RESTRICTION_DELETED:
      const newAgeRestrictions = state.ageRestrictions.filter((item: IAgeRestriction) => {
        return item.ruleId !== action.payload;
      });
      return { ...state, ageRestrictions: newAgeRestrictions };
    case SAVE_AGE_RESTRICTION:
      return {
        ...state,
        error: null,
        ageRestrictionSaved: false,
        syncing: true,
      };
    case AGE_RESTRICTIONS_SAVED:
      return {
        ...state,
        ageRestrictionSaved: !state.ageRestrictionSaved,
        syncing: false,
      };
    case AGE_RESTRICTION_ADDED:
      const ruleExists = state.ageRestrictions.find(
        (rule) => rule.ruleId === action.payload.ruleId
      );
      if (ruleExists) {
        return {
          ...state,
          ageRestrictions: state.ageRestrictions.map((el) =>
            el.ruleId === action.payload.ruleId ? action.payload : el
          ),
        };
      }
      return {
        ...state,
        ageRestrictions: [...state.ageRestrictions, action.payload],
      };
    case SYNC_FAILED:
      return { ...state, syncing: false, error: action.payload };
    default:
      return state;
  }
};
